import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { confirmMollieBatch, getMollieBatches, getMollieSettlementOrders } from 'src/api/mollie-batch';
import {
    CONFIRM_MOLLIE_BATCH,
    fetchMollieBatches,
    FETCH_MOLLIE_BATCHES,
    FETCH_MOLLIE_SETTLEMENT_ORDERS,
    requestConfirmMollieBatch,
    requestConfirmMollieBatchFailure,
    requestConfirmMollieBatchSuccess,
    requestMollieBatches,
    requestMollieBatchesFailure,
    requestMollieBatchesSuccess,
    requestMollieSettlementOrders,
    requestMollieSettlementOrdersFailure,
    requestMollieSettlementOrdersSuccess,
} from './actions';

function* fetchMollieBatchesSaga(action: AnyAction): SagaIterator {
    yield put(requestMollieBatches());

    const { error, response } = yield call(
        getMollieBatches,
        action.pageable,
        action.settlementId,
        action.confirmedState
    );

    if (error) {
        yield put(requestMollieBatchesFailure(error));
    } else {
        yield put(requestMollieBatchesSuccess(response));
    }
}

export function* generateFetchMollieBatchesWatcher() {
    yield takeLatest(FETCH_MOLLIE_BATCHES, fetchMollieBatchesSaga);
}

function* fetchMollieSettlementOrdersSaga(action: AnyAction): SagaIterator {
    yield put(requestMollieSettlementOrders());

    const { error, response } = yield call(getMollieSettlementOrders, action.settlementId);

    if (error) {
        yield put(requestMollieSettlementOrdersFailure(error));
    } else {
        yield put(requestMollieSettlementOrdersSuccess(response));
    }
}

export function* generateFetchMollieSettlementOrdersWatcher() {
    yield takeLatest(FETCH_MOLLIE_SETTLEMENT_ORDERS, fetchMollieSettlementOrdersSaga);
}

function* confirmMollieBatchSaga(action: AnyAction): SagaIterator {
    yield put(requestConfirmMollieBatch());

    const { error, response } = yield call(confirmMollieBatch, action.id, action.mollieBatchConfirmationRequest);

    if (error) {
        yield put(requestConfirmMollieBatchFailure(error));
    } else {
        yield put(requestConfirmMollieBatchSuccess(response));
        const lastFilter = yield select((state: any) => state.offsettingMollieBatch.lastFilter);
        yield put(fetchMollieBatches(lastFilter?.pageable, lastFilter?.settlementId, lastFilter?.confirmedState));
    }
}

export function* generateConfirmMollieBatchWatcher() {
    yield takeLatest(CONFIRM_MOLLIE_BATCH, confirmMollieBatchSaga);
}
